import { fromJS } from 'immutable';

import { combineReducerArray } from '../utils/helpers';

import {
  OPEN_TEAMS_WIZZARD,
  CLOSE_TEAMS_WIZZARD,
  WIZZARD_ADD_TEAM_SET_TEAM_NAME,
  WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION,
  WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS,
  WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER,
  WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER,
  newUsers,
  myTeamsList,
  REQUEST_INVITE_COMPANY,
  REQUEST_ADD_TEAM_SUCCESS,
  REQUEST_INVITE_MORE_MEMBERS,
} from './types';
import moveTeamMembersReducerObject from './moveTeamMembers/reducer';

export * from './actions';

const initialState = fromJS({
  teamsWizzard: {
    isOpen: false,
    startPath: false,
    options: false,
  },
  wizzardAddCompany: {
    name: null,
    managerEmail: null,
  },
  wizzardAddTeam: {
    name: null,
    champion: null,
    teamId: null,
    members: [],
  },
  wizzardAddMoreMembers: {
    teamId: null,
    availableTeams: [],
    members: [],
    network: { loading: false, error: false },
  },
  wizzardAddMoreUsers: {
    data: [],
    network: { loading: false, error: false },
  },
  wizzardMoveTeamMembers: {
    memberIds: [],
    sourceTeamId: false,
    targetTeamId: false,
    updatedMember: [],
    network: { loading: false, error: false },
  },
});

const openTeamsWizzard = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['teamsWizzard', 'isOpen'], true)
      .setIn(['teamsWizzard', 'startPath'], action.startPath)
      .setIn(['teamsWizzard', 'options'], fromJS(action.options)),
  );

const closeTeamsWizzard = (state) =>
  state.withMutations((s) =>
    s
      .setIn(['teamsWizzard', 'isOpen'], false)
      .setIn(['teamsWizzard', 'options'], null)
      .set('wizzardAddCompany', initialState.get('wizzardAddCompany'))
      .set('wizzardAddTeam', initialState.get('wizzardAddTeam'))
      .set('wizzardAddMoreMembers', initialState.get('wizzardAddTeam'))
      .set('wizzardMoveTeamMembers', initialState.get('wizzardMoveTeamMembers')),
  );

const setWizzardTeamNameReducer = (state, action) =>
  state.setIn(['wizzardAddTeam', 'name'], action.teamName);

const setWizzardTeamChampionReducer = (state, action) =>
  state.setIn(['wizzardAddTeam', 'champion'], action.email);

const setWizzardTeamMembersReducer = (state, action) =>
  state.updateIn(['wizzardAddTeam', 'members'], (oldList) =>
    oldList.concat(fromJS(action.members)),
  );

const removeWizzardTeamMemberReducer = (state, action) =>
  state.updateIn(['wizzardAddTeam', 'members'], (list) =>
    list.filter((member) => member.get('email') !== action.email),
  );

const updateWizzardTeamMemberReducer = (state, action) =>
  state.updateIn(['wizzardAddTeam', 'members'], (list) =>
    list.update(
      list.findIndex((member) => member.get('email') === action.email),
      (member) => member.set('role', action.role),
    ),
  );

const requestInviteNewUsersReducer = (state) =>
  state.setIn(['wizzardAddMoreUsers', 'network', 'loading'], true);

const requestInviteNewUsersSuccessReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['wizzardAddMoreUsers', 'network', 'loading'], false)
      .setIn(['wizzardAddMoreUsers', 'network', 'error'], false)
      .setIn(['wizzardAddMoreUsers', 'data'], action.userEmails),
  );

const requestInviteNewUsersFailureReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['wizzardAddMoreUsers', 'network', 'loading'], false)
      .setIn(['wizzardAddMoreUsers', 'network', 'error'], action.error),
  );

const requestMyTeamsListReducer = (state) =>
  state.setIn(['wizzardAddMoreMembers', 'network', 'loading'], true);

const requestMyTeamsListSuccessReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['wizzardAddMoreMembers', 'network', 'loading'], false)
      .setIn(['wizzardAddMoreMembers', 'network', 'error'], false)
      .setIn(['wizzardAddMoreMembers', 'availableTeams'], fromJS(action.response)),
  );

const requestMyTeamsListFailureReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['wizzardAddMoreMembers', 'network', 'loading'], false)
      .setIn(['wizzardAddMoreMembers', 'network', 'error'], action.error),
  );

const requestInviteCompanyReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['wizzardAddCompany', 'name'], action.payload.name)
      .setIn(['wizzardAddCompany', 'managerEmail'], action.payload.email),
  );

const requestAddTeamSuccessReducer = (state, action) =>
  state.withMutations((s) => s.setIn(['wizzardAddTeam', 'teamId'], action.teamId));

const requestInviteMoreMembersReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['wizzardAddMoreMembers', 'members'], action.payload.users)
      .setIn(['wizzardAddMoreMembers', 'teamId'], action.payload.team),
  );

const teamWizzardReducerObject = {
  [OPEN_TEAMS_WIZZARD]: (state, action) => openTeamsWizzard(state, action),
  [CLOSE_TEAMS_WIZZARD]: (state, action) => closeTeamsWizzard(state, action),
  [WIZZARD_ADD_TEAM_SET_TEAM_NAME]: (state, action) => setWizzardTeamNameReducer(state, action),
  [WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION]: (state, action) =>
    setWizzardTeamChampionReducer(state, action),
  [WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS]: (state, action) =>
    setWizzardTeamMembersReducer(state, action),
  [WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER]: (state, action) =>
    removeWizzardTeamMemberReducer(state, action),
  [WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER]: (state, action) =>
    updateWizzardTeamMemberReducer(state, action),
  [myTeamsList.request]: (state, action) => requestMyTeamsListReducer(state, action),
  [myTeamsList.success]: (state, action) => requestMyTeamsListSuccessReducer(state, action),
  [myTeamsList.failure]: (state, action) => requestMyTeamsListFailureReducer(state, action),
  [REQUEST_ADD_TEAM_SUCCESS]: (state, action) => requestAddTeamSuccessReducer(state, action),
  [REQUEST_INVITE_COMPANY]: (state, action) => requestInviteCompanyReducer(state, action),
  [REQUEST_INVITE_MORE_MEMBERS]: (state, action) => requestInviteMoreMembersReducer(state, action),
  [newUsers.request]: (state, action) => requestInviteNewUsersReducer(state, action),
  [newUsers.success]: (state, action) => requestInviteNewUsersSuccessReducer(state, action),
  [newUsers.failure]: (state, action) => requestInviteNewUsersFailureReducer(state, action),
};

export default combineReducerArray(initialState, [
  teamWizzardReducerObject,
  moveTeamMembersReducerObject,
]);
